module.exports = __webpack_public_path__ + "static/img/banner_splj.3d32243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/banner/banner_splj.jpg
// module id = IIiN
// module chunks = 0